import React from 'react'
import ChatSection from './components/chatSection/ChatSection'
import Jarvis_Bg from '../../images/jarvis/png/jarvis_bg.png'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

const Jarvis = () => {

    const location = useLocation()
    const { astra, milestone, date, section } = location.state || {}

    return (
        <>
            <Helmet link={
                [{ "rel": "stylesheet", "href": 'css/leaderboard.css' }]
            } />
            <div
                style={{
                    display: "flex"
                }}
            >
                <div
                    style={{
                        backgroundImage: `url(${Jarvis_Bg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "100vh",
                        width: "100%",
                        maxWidth: "550px",
                        overflow: "scroll"
                    }}
                >
                    <div
                        style={{
                            paddingLeft: "10px",
                            paddingRight: "15px",
                            paddingTop: "10px"
                        }}
                    >
                        <ChatSection selectedAstra={astra} milestone={milestone} date={date} section={section} />
                    </div>
                </div>
                <div className='bg'></div>
            </div >
        </>
    )
}

export default Jarvis